module.exports = __webpack_public_path__ + "static/media/card-3.fb6b1309.svg";